import store from '../../utils/localStorageFallback';

document.addEventListener('DOMContentLoaded', () => {
  // Don't run on investments, using own custom menu. See investments tax-nav.js.
  if (
    document.getElementById('page').classList.contains('investments') ||
    document.getElementById('page').classList.contains('real-estate') ||
    document.getElementById('page').classList.contains('capital')
  ) {
    return;
  }

  document.addEventListener('click', (event) => {
    // Grab all the li elements
    const list = document.querySelectorAll('ul#menu-primary > li');
    const primaryMenu = document.querySelectorAll('div.primaryNav--desktop')[0];
    Array.from(list).forEach((element) => {
      if (event.target === element) {
        if (event.target.classList.contains('inactive')) {
          Array.from(list).forEach((node) => {
            node.classList.remove('active');
            node.classList.add('inactive');
          });
          event.target.classList.add('active');
          event.target.classList.remove('inactive');
        } else {
          event.target.classList.add('inactive');
          event.target.classList.remove('active');
        }
      } else if (primaryMenu !== event.target) {
        element.classList.add('inactive');
        element.classList.remove('active');
      }
    });
  });
});

const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  const modalDivs = document.querySelectorAll('.top-nav--modal');
  const openModalDivs = document.querySelectorAll('.openModal');
  const arrows = document.querySelectorAll('.openModal svg');

  document.addEventListener('click', (event) => {
    for (let i = 0; i < modalDivs.length; i += 1) {
      const modalDiv = modalDivs[i];
      const openModalDiv = openModalDivs[i];
      const arrow = arrows[i];

      if (event.target === openModalDiv) {
        if (window.getComputedStyle(modalDiv).display === 'none') {
          modalDiv.style.display = 'block'; // Change to 'block' to ensure it occupies space
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }

          // Calculate and set the modal position under the container
          const containerRect = openModalDiv.getBoundingClientRect();
          modalDiv.style.left = `calc(${containerRect.left}px - 10px)`;
        } else {
          modalDiv.style.display = 'none';
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        }
      } else {
        modalDiv.style.display = 'none';
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)';
        }
      }

      const allLinks = modalDiv.querySelectorAll('a');
      Array.from(allLinks).forEach((link) => {
        link.classList.remove('active');
      });

      const currentBaseURL = window.location.origin;
      Array.from(allLinks).forEach((link) => {
        if (link.href.startsWith(currentBaseURL)) {
          if (link.href.includes('investments')) {
            const version = store('version');
            if (link.href.includes(version)) {
              link.classList.add('active');
            }
          } else {
            link.classList.add('active');
          }
        }
      });

      if (document.body.classList.contains('unidentified')) {
        Array.from(allLinks).forEach((link) => {
          link.classList.remove('active');
        });
      }
    }
  });

  window.addEventListener('resize', () => {
    for (let i = 0; i < modalDivs.length; i += 1) {
      const modalDiv = modalDivs[i];
      const openModalDiv = openModalDivs[i];

      if (modalDiv.style.display === 'block' && openModalDiv) {
        const containerRect = openModalDiv.getBoundingClientRect();
        modalDiv.style.left = `calc(${containerRect.left}px - 10px)`;
      }
    }
  });

  const topNavContainerMobile = document.querySelector('.top-nav--container--mobile');
  if (topNavContainerMobile) {
    topNavContainerMobile.addEventListener('click', () => {
      const toggleButton = document.getElementById('primaryNav-toggle');
      if (toggleButton) {
        toggleButton.click();
      }
    });
  }

  const topNav = document.querySelector('.top-nav--container');
  const siteHeader = document.querySelector('.site-header');
  let siteHeaderStart = siteHeader.offsetTop;
  const siteHeaderTransparentHeight = siteHeader.classList.contains(
    'site-header--ventures-transparent',
  )
    ? siteHeader.offsetHeight
    : null;
  const mqFromTablet = window.matchMedia('(max-width: 1024px)');
  const bannerNotification = document.querySelector('.bannerNotification.banner-isSticky-true');

  const handleHeaderPosition = () => {
    const scrollPosition = window.scrollY;

    if (!mqFromTablet.matches) {
      if (scrollPosition >= siteHeaderStart) {
        siteHeader.style.top = `0px`;
        if (!siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.add('fixed--withUtilityNav');
        }

        if (bannerNotification) {
          bannerNotification.style.top = null;
        }
      } else if (siteHeaderTransparentHeight && scrollPosition === 0 && bannerNotification) {
        siteHeader.style.top = null;
        bannerNotification.style.top = null;
      } else {
        siteHeader.style.top = `${siteHeaderStart - scrollPosition}px`;
        if (siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.remove('fixed--withUtilityNav');
        }

        let siteHeaderHeight = siteHeader.offsetHeight;
        if (siteHeaderTransparentHeight) {
          siteHeaderHeight = siteHeaderTransparentHeight - 32;
        }

        if (bannerNotification) {
          bannerNotification.style.top = `${siteHeaderStart + siteHeaderHeight - scrollPosition}px`;
        }
      }
    }
  };

  if (topNav !== null) {
    handleHeaderPosition();

    window.addEventListener('scroll', handleHeaderPosition);

    window.addEventListener('resize', () => {
      if (mqFromTablet.matches) {
        siteHeader.style.top = null;
      } else {
        siteHeaderStart = topNav.offsetHeight;
        handleHeaderPosition();
      }
    });
  }
});
